import React from "react";
import { MultiSelect } from "./multiSelect";
import { SingleSelect } from "./singleSelect";
import type { FormBuilderOption, FormBuilderQuestion, FormRule, ProductFamilyFilter } from "../../../features/custom-forms";

interface QuestionAnswerProps {
  questionValue: FormBuilderQuestion;
  pIndex: number;
  value: FormBuilderOption;
  index: number;
  gotoOption: Array<{ key: string; value: string }>;
  getOptionValue: (value: string, index: number, pIndex: number) => void;
  getGotoValue: (value: string, pIndex: number, index: number) => void;
  deleteAnswerOption: (index: number, pIndex: number) => void;
  productFamilyCode: (familyCodes: string[], index: number, pIndex: number, filter: ProductFamilyFilter) => void;
  productMaterialCode: (materialCodes: string[], index: number, pIndex: number) => void;
  addRuleData: (rule: FormRule | undefined, pIndex: number, index?: number) => void;
  productAttributeOrderChange: (direction: "up" | "down", index: number, pIndex: number) => void;
}

const QuestionAnswer: React.FC<QuestionAnswerProps> = ({
  questionValue,
  pIndex,
  value,
  index,
  gotoOption,
  getOptionValue,
  getGotoValue,
  deleteAnswerOption,
  productFamilyCode,
  productMaterialCode,
  addRuleData,
  productAttributeOrderChange,
}) => {
  const { type, optionType } = questionValue;
  const length = questionValue?.options?.length;
  if (type === "singleselect") {
    return (
      <SingleSelect
        name="option"
        index={index}
        count={length}
        value={value}
        pIndex={pIndex}
        getOptionValue={getOptionValue}
        getGotoValue={getGotoValue}
        gotoOption={gotoOption}
        deleteAnswerOption={deleteAnswerOption}
        optionType={optionType}
        getFamilyCode={(code: string[], i: number, p: number, filter: ProductFamilyFilter) => productFamilyCode(code, i, p, filter)}
        getMaterialCode={(code: string[], i: number, p: number) => productMaterialCode(code, i, p)}
        addRuleData={() => addRuleData(value?.rule, pIndex, index)}
        productAttributeOrderChange={productAttributeOrderChange}
      />
    );
  }

  if (type === "multiselect") {
    return (
      <MultiSelect
        index={index}
        value={value}
        pIndex={pIndex}
        getOptionValue={getOptionValue}
        getGotoValue={getGotoValue}
        gotoOption={gotoOption}
        deleteAnswerOption={deleteAnswerOption}
      />
    );
  }

  return null;
};

export default QuestionAnswer;
